const round = (value, decimals = 2) => {
  const roundFactor = 10 ** decimals
  return Math.round((value +  Number.EPSILON) * roundFactor) / roundFactor
}

export default round
